module.exports = __webpack_public_path__ + "static/Step 2-0cc962c45c93c8e5a54532e94e4b7746.png";